import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column gr-8" },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "mb-4",
            class: _setup.isMobile ? "text-subtitle-1" : "text-h6",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    `Как самостоятельно зарегистрировать клинику на {siteName}`,
                    { ..._setup.options, siteName: _setup.siteName }
                  )
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          { staticClass: "d-flex flex-column gr-2 text-body-1 pl-5 mb-2" },
          [
            _c("li", [
              _vm._v(_vm._s(_setup.t("Выберите нужный город", _setup.options))),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _setup.t("Найдите страницу вашей клиники", _setup.options)
                )
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_setup.t("Нажмите «Ваша страница?»", _setup.options))
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _setup.t(
                    "Заполните все поля и следуйте инструкции",
                    _setup.options
                  )
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text-body-1 primary--text link-decoration-none",
            attrs: {
              href: _setup.context.request.country.is_russia
                ? "https://help.prodoctorov.ru/kak-zaregistrirovat-svoyu-kliniku-na-portale-prodoktorov/"
                : "https://help.ydoc.me/kak-zaregistrirovat-svoyu-kliniku-na-portale-ydoc/",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(_setup.t("Подробнее в статье", _setup.options)))]
        ),
      ]),
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            VBtn,
            {
              attrs: { color: "primary", depressed: "" },
              on: { click: _setup.openSearch },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.t("Найти клинику", _setup.options)) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.context.company_contact.email
        ? _c("div", { staticClass: "d-flex flex-column" }, [
            _c("div", { staticClass: "text-body-1 mb-3" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t(
                      "Если не нашли свою страницу или есть другие трудности, пришлите название клиники и полный адрес главного офиса на" /* eslint-disable-line */,
                      _setup.options
                    )
                  ) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  staticClass: "primary--text link-decoration-none",
                  attrs: {
                    href: `mailto:${_setup.context.company_contact.email}`,
                  },
                },
                [_vm._v(_vm._s(_setup.context.company_contact.email))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-body-1" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t("Ответим в течение 1 рабочего дня", _setup.options)
                  ) +
                  ".\n    "
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }